import {
  ALL_POSTS_LIST,
  ALL_POSTS_LIST_COLLAPSED,
  VIEW_ALL_POSTS_BUTTON
} from '../classnames/blog';
import { HIDDEN } from '../classnames/design-system';

export default class PostList {
  viewAllButton = document.querySelector(`.${VIEW_ALL_POSTS_BUTTON}`);

  viewAllPosts = (event) => {
    event.preventDefault();
    document.querySelector(`.${ALL_POSTS_LIST}`).classList.remove(ALL_POSTS_LIST_COLLAPSED);
    this.viewAllButton.classList.add(HIDDEN);
  };

  initializeEventListeners = () => {
    if (this.viewAllButton) {
      this.viewAllButton.addEventListener('click', this.viewAllPosts);
    }
  };
}
